import React from 'react';

import { Chip, ChipProps, SvgIconProps } from '@mui/material';

interface Props extends ChipProps {
  label: string;
  icon?: React.ReactElement<SvgIconProps>;
}

const CustomChip: React.FC<Props> = ({ icon, label, ...props }) => {
  return (
    <Chip
      sx={{
        background: '#FFECF1',
        padding: '15px 10px',
        borderRadius: '5px',
        color: '#6D264C',
      }}
      icon={icon}
      label={label}
      {...props}
    />
  );
};

export default CustomChip;
